export default __webpack_public_path__ + "c09d28b75486ca64ab3d2c54066db825.png";